var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10C6 8.34315 7.34314 7 9 7C10.6569 7 12 8.34315 12 10C12 11.6569 10.6569 13 9 13C7.34314 13 6 11.6569 6 10ZM9 9C8.44772 9 8 9.44771 8 10C8 10.5523 8.44772 11 9 11C9.55228 11 10 10.5523 10 10C10 9.44771 9.55228 9 9 9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7C14.4477 7 14 7.44772 14 8C14 8.55228 14.4477 9 15 9H17C17.5523 9 18 8.55228 18 8C18 7.44772 17.5523 7 17 7H15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 11.4477 14.4477 11 15 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H15C14.4477 13 14 12.5523 14 12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15C6.44772 15 6 15.4477 6 16C6 16.5523 6.44772 17 7 17H17C17.5523 17 18 16.5523 18 16C18 15.4477 17.5523 15 17 15H7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.18563C1 4.83174 2.9833 3 5.33333 3H18.6667C21.0167 3 23 4.83174 23 7.18563V17.8044C23 20.1583 21.0167 21.99 18.6667 21.99H5.33333C2.9833 21.99 1 20.1583 1 17.8044V7.18563ZM5.33333 5C4.00147 5 3 6.02077 3 7.18563V17.8044C3 18.9692 4.00147 19.99 5.33333 19.99H18.6667C19.9985 19.99 21 18.9692 21 17.8044V7.18563C21 6.02077 19.9985 5 18.6667 5H5.33333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployer);
export default __webpack_public_path__ + "static/media/employer.18490b38f67be25d65b5702fb1828390.svg";
export { ForwardRef as ReactComponent };